import React from 'react';
import { makeStyles } from 'react-scale/components/design-system';
import { ReportButtonProps } from 'react-scale/components/scalers/tasks/reportTask/ReportTask';

export const ReviewReportButton: React.FC<ReportButtonProps> = ({
  onClick,
  disabled,
  buttonText,
}: ReportButtonProps) => {
  const classes = useStyles();
  return (
    <div>
      <button
        className={classes.reviewerReportButton}
        style={{
          width: buttonText ? 95 : 210,
        }}
        onClick={onClick}
        disabled={disabled}
      >
        <img
          className={classes.reportIcon}
          src="/static/img/components/labeler/reviewer-report.svg"
          alt=""
        />
        <div className={classes.buttonText} style={buttonText ? { width: 50 } : {}}>
          {buttonText || 'Report Sensitive Content '}
        </div>
      </button>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  reportIcon: { marginLeft: 4 },
  reviewerReportButton: {
    display: 'flex',
    border: '1px solid var(--color-RemoRed)',
    fontSize: 14,
    borderRadius: 8,
    height: 30,
    cursor: 'pointer',
    color: '#000000',
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    '&:disabled': {
      opacity: 0.4,
    },
  },
  buttonText: {
    marginLeft: 5,
    color: 'red',
    fontWeight: 600,
  },
}));
